/*
Images
*/
const files = require.context(__dirname, false, /\.(png|jpg|gif|svg)$/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./project/client/src/site__mhf/images/index.js